// src/common/SEOConfig.js
// ================================================================
// CENTRALIZED SEO — Sab pages ki SEO settings EK JAGAH
// Kuch change karna ho → sirf is file mein aao
// ================================================================

const SEOConfig = {

  home: {
    title: "AstroBhagya - Online Trusted Astrology Predictions by Best Astrologer",
    description: "AstroBhagya offers free online astrology predictions and daily horoscope by verified astrologers. Trusted by thousands for accurate life guidance.",
    keywords: "AstroBhagya, astrology predictions, free daily horoscope, kundali matching, online astrologer India",
    canonical: "https://www.astrobhagya.com/",
  },

  dailyHoroscope: {
    title: "Free Daily Horoscope 2025 - All 12 Zodiac Signs | AstroBhagya",
    description: "Read your free daily horoscope for all 12 zodiac signs. Accurate daily predictions for love, career, health and finance by expert astrologers.",
    keywords: "daily horoscope, free horoscope today, zodiac predictions, daily astrology 2025",
    canonical: "https://www.astrobhagya.com/daily-horoscope/today/aries",
  },

  // Dynamic — sign aur day se automatically title banega
  // Usage: SEOConfig.dailyHoroscopeSign("aries", "today")
  dailyHoroscopeSign: (sign, day) => {
    const s = sign ? sign.charAt(0).toUpperCase() + sign.slice(1).toLowerCase() : "Aries";
    const d = day === "today" ? "Today" : day === "yesterday" ? "Yesterday" : day === "tomorrow" ? "Tomorrow" : "Today";
    return {
      title: `${s} Daily Horoscope ${d} 2025 | AstroBhagya`,
      description: `Read ${s} daily horoscope for ${d}. Accurate ${s} predictions for love, career, health and finance by verified expert astrologers on AstroBhagya.`,
      keywords: `${s} daily horoscope, ${s} horoscope ${d.toLowerCase()}, ${s} astrology prediction 2025`,
      canonical: `https://www.astrobhagya.com/daily-horoscope/${day ? day.toLowerCase() : "today"}/${sign ? sign.toLowerCase() : "aries"}`,
    };
  },

  yearlyHoroscope: {
    title: "Yearly Horoscope 2025 - Annual Predictions All Zodiac Signs | AstroBhagya",
    description: "Complete yearly horoscope 2025 for all 12 zodiac signs. Detailed annual predictions for love, career, health and finance by AstroBhagya expert astrologers.",
    keywords: "yearly horoscope 2025, annual horoscope, zodiac yearly predictions, 2025 astrology forecast",
    canonical: "https://www.astrobhagya.com/yearly-horoscope",
  },

  // Dynamic — Usage: SEOConfig.yearlyHoroscopeSign("aries")
  yearlyHoroscopeSign: (sign) => {
    const s = sign ? sign.charAt(0).toUpperCase() + sign.slice(1).toLowerCase() : "Aries";
    return {
      title: `${s} Yearly Horoscope 2025 - Annual Predictions | AstroBhagya`,
      description: `Complete ${s} yearly horoscope 2025. Detailed annual predictions for ${s} covering love, career, health and finance by AstroBhagya expert astrologers.`,
      keywords: `${s} yearly horoscope 2025, ${s} annual horoscope, ${s} 2025 predictions`,
      canonical: `https://www.astrobhagya.com/yearly-horoscope/${sign ? sign.toLowerCase() : "aries"}`,
    };
  },

  blogs: {
    title: "Astrology Blogs - Tips, Insights & Predictions | AstroBhagya",
    description: "Read the latest astrology blogs, tips and insights by expert astrologers on AstroBhagya. Discover horoscope news, zodiac compatibility and more.",
    keywords: "astrology blog, horoscope articles, zodiac tips, astrology insights, AstroBhagya blog",
    canonical: "https://www.astrobhagya.com/blogs",
  },

  // Dynamic — Usage: SEOConfig.blogDetail("Title", "Desc", "slug")
  blogDetail: (title, description, slug) => ({
    title: `${title} | AstroBhagya Blog`,
    description: description || "Read the latest astrology blog on AstroBhagya by expert astrologers.",
    keywords: `${title}, astrology blog, AstroBhagya`,
    canonical: `https://www.astrobhagya.com/blogs/${slug}`,
  }),

  callWithAstrologer: {
    title: "Call with Astrologer Online - Talk to Expert Astrologer | AstroBhagya",
    description: "Talk to verified expert astrologers on call. Get accurate predictions for love, career, marriage and life problems. First call free on AstroBhagya.",
    keywords: "call with astrologer, talk to astrologer online, astrologer phone consultation India",
    canonical: "https://www.astrobhagya.com/call-with-astrologer",
  },

  chatWithAstrologer: {
    title: "Chat with Astrologer Online - Live Astrology Chat | AstroBhagya",
    description: "Chat live with verified expert astrologers. Get instant predictions for love, career, marriage and life problems. First chat free on AstroBhagya.",
    keywords: "chat with astrologer, live astrology chat, online astrologer chat India",
    canonical: "https://www.astrobhagya.com/chat-with-astrologer",
  },

  bestAstrologer: {
    title: "Best Astrologers Online - Verified Expert Astrologers | AstroBhagya",
    description: "Connect with India's best verified online astrologers on AstroBhagya. Get accurate predictions from top-rated astrologers for love, career and life.",
    keywords: "best astrologer online, verified astrologer India, top astrologer",
    canonical: "https://www.astrobhagya.com/bestastrologer",
  },

  festivals: {
    title: "Hindu Festival Calendar 2025 - Auspicious Dates & Muhurat | AstroBhagya",
    description: "Complete Hindu festival calendar 2025 with auspicious dates, muhurat and puja timings. Find all important festivals and their astrological significance.",
    keywords: "Hindu festival calendar 2025, festival muhurat, auspicious dates, puja calendar",
    canonical: "https://www.astrobhagya.com/festival",
  },

  about: {
    title: "About AstroBhagya - India's Trusted Online Astrology Platform",
    description: "Know about AstroBhagya — India's most trusted platform connecting users with verified astrologers for accurate astrology predictions and life guidance.",
    keywords: "about AstroBhagya, trusted astrology platform India, verified astrologers",
    canonical: "https://www.astrobhagya.com/about",
  },

  faq: {
    title: "Frequently Asked Questions - Astrology FAQs | AstroBhagya",
    description: "Find answers to common astrology questions on AstroBhagya. Learn about horoscopes, kundali, zodiac signs, astrologer consultations and more.",
    keywords: "astrology FAQ, horoscope questions, AstroBhagya help, zodiac FAQ",
    canonical: "https://www.astrobhagya.com/faq",
  },

  astrologerRegistration: {
    title: "Join as Astrologer - Register on AstroBhagya | Earn Online",
    description: "Register as an astrologer on AstroBhagya and start earning by helping people with accurate predictions. Join India's fastest growing astrology platform.",
    keywords: "astrologer registration, join AstroBhagya, become astrologer online",
    canonical: "https://www.astrobhagya.com/astrologer-registration",
  },

  privacyPolicy: {
    title: "Privacy Policy | AstroBhagya",
    description: "Read AstroBhagya's privacy policy. Learn how we collect, use and protect your personal information on our astrology platform.",
    keywords: "AstroBhagya privacy policy, data protection",
    canonical: "https://www.astrobhagya.com/privacy-policy",
  },

  termsAndConditions: {
    title: "Terms and Conditions | AstroBhagya",
    description: "Read AstroBhagya's terms and conditions. Understand the rules and guidelines for using our astrology platform and services.",
    keywords: "AstroBhagya terms and conditions, user agreement",
    canonical: "https://www.astrobhagya.com/terms-and-conditions",
  },

  refundPolicy: {
    title: "Refund Policy | AstroBhagya",
    description: "Read AstroBhagya's refund policy. Learn about our wallet refund process and guidelines for astrology consultation services.",
    keywords: "AstroBhagya refund policy, wallet refund",
    canonical: "https://www.astrobhagya.com/refund-policy",
  },

  wallet: {
    title: "My Wallet - Add Balance & Recharge | AstroBhagya",
    description: "Manage your AstroBhagya wallet. Add balance, view transaction history and recharge to consult with expert astrologers anytime.",
    keywords: "AstroBhagya wallet, add balance, recharge wallet",
    canonical: "https://www.astrobhagya.com/wallet",
  },

};

export default SEOConfig;